import React from 'react';
import { profileData } from '../../data/profileData';
import { Section } from '../ui';
import './About.css';

const About: React.FC = () => {
  const [lede, ...rest] = profileData.about.paragraphs;

  return (
    <Section id="about" title="About" eyebrow="Who I am" className="about">
      <div className="about__narrative">
        <p className="about__lede">{lede}</p>
        {rest.map((paragraph) => (
          <p key={paragraph}>{paragraph}</p>
        ))}
      </div>
    </Section>
  );
};

export default About;
